<template>
  <div class="dialog-add-agent-app-wrapper">
    <el-dialog title="添加代理商应用" width="70%" :visible="visible" @open="onDialogOpen" @close="onDialogClose">

      <el-form label-position="top" ref="form" class="form" :rules="formRules" :model="form">

        <el-form-item label="代理商" prop="agentid">
          <el-select
            filterable
            default-first-option
            v-model="form.agentid">
            <el-option
              v-for="agent in agentList"
              :key="agent.agentid"
              :label="agent.agentname"
              :value="agent.agentid" />
          </el-select>
        </el-form-item>

        <el-form-item
          v-for="(app, index) in form.app"
          :key="'app' + index"
          :label="'应用' + index" >

          <el-select
            filterable
            class="inline-item"
            style="width: 30%;"
            default-first-option
            v-model="app.app_store_id">
            <el-option
              v-for="app in appList"
              :key="app.app_store_id"
              :label="app.app_name_i18n[0].name"
              :value="app.app_store_id">
            </el-option>
          </el-select>

          <el-input
            class="inline-item"
            style="width: 30%;"
            type="number"
            v-model="app.duration"
            v-if="app.time_step !== 'forever'"
            placeholder="请输入有效时间" />

          <el-select
            class="inline-item"
            style="width: 30%;"
            default-first-option
            v-model="app.time_step">
            <el-option label="秒" value="second" />
            <el-option label="分钟" value="minute" />
            <el-option label="小时" value="hour" />
            <el-option label="天" value="day" />
            <el-option label="周" value="week" />
            <el-option label="月" value="month" />
            <el-option label="年" value="year" />
            <el-option label="永久" value="forever" />
          </el-select>

          <el-button
            type="danger"
            size="mini"
            @click="onAppDelete(index)">删除</el-button>
        </el-form-item>

        <el-form-item style="display: flex; justify-content: center;">
          <el-button type="danger" @click="onFormSubmit">确定</el-button>
          <el-button type="info" @click="onAppAdd">添加应用</el-button>
          <el-button @click="onFormCancel">取消</el-button>
        </el-form-item>

      </el-form>

    </el-dialog>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  name: 'DialogAddAgentApp',
  props: {
    visible: {
      type: Boolean,
      required: true
    }
  },
  data () {
    return {
      formRules: {
        agentid: [
          { required: true, message: '请选择需要添加应用的代理商', trigger: 'change' }
        ]
      },
      form: {
        agentid: '',
        app: []
      }
    }
  },
  computed: {
    ...mapState('agent', [
      'agentList'
    ]),
    ...mapState('store', [
      'appList'
    ])
  },
  methods: {
    ...mapActions('agent', [
      'getAgents'
    ]),
    ...mapActions('store', [
      'addAgentApp'
    ]),

    onAppAdd () {
      this.form.app.push({
        app_store_id: '',
        extend: [],
        duration: '',
        time_step: 'second'
      })
    },
    onAppDelete (index) {
      if (this.form.app.length <= 1) {
        this.$message({
          type: 'error',
          message: '至少需要包含一个应用'
        })
        return
      }
      this.form.app.splice(index, 1)
    },

    // 整理表单，验证数据
    cleanFormAndSubmit () {
      const clean = JSON.parse(JSON.stringify(this.form))

      // 检查套餐字段信息
      for (let i = 0; i < clean.app.length; i++) {
        const app = clean.app[i]

        // 计算过期时间
        switch (app.time_step) {
          case 'second':
            app.duration = parseInt(app.duration)
            break
          case 'minute':
            app.duration = parseInt(app.duration) * 60
            break
          case 'hour':
            app.duration = parseInt(app.duration) * 3600
            break
          case 'day':
            app.duration = parseInt(app.duration) * 86400
            break
          case 'week':
            app.duration = parseInt(app.duration) * 604800
            break
          case 'month':
            app.duration = parseInt(app.duration) * 2592000
            break
          case 'year':
            app.duration = parseInt(app.duration) * 31536000
            break
          default:
            app.duration = 3153600000
        }
        delete app.time_step

        if (isNaN(app.duration)) {
          this.$meesage({
            type: 'error',
            message: '请输入合法的过期时间'
          })
          return
        }
        clean.app[i] = app
      }

      // 提交表单
      this.performSubmit(clean)
    },
    async performSubmit (cleanForm) {
      try {
        await this.addAgentApp(cleanForm)

        this.$emit('update:visible', false)
        this.$emit('data-change')
      } catch (err) {
        this.$message({
          type: 'error',
          message: '添加代理商应用失败'
        })
        console.log(err)
      }
    },

    onFormSubmit () {
      this.$refs['form'].validate(valid => {
        if (valid) {
          this.cleanFormAndSubmit()
        }
      })
    },
    onFormCancel () {
      this.$emit('update:visible', false)
    },

    onDialogOpen () {
      for (let i = 0; i < this.appList.length; i++) {
        const app = this.appList[i]
        this.form.app.push({
          app_store_id: app.app_store_id,
          extend: [],
          duration: app.package[0].duration || 0,
          time_step: 'second'
        })
      }

      this.getAgents({
        page: 1,
        pageSize: 9999
      })
    },
    onDialogClose () {
      this.$emit('update:visible', false)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../../../assets/sass/base.scss';

.dialog-add-agent-app-wrapper {

  .inline-item {
    margin-right: 8px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/op/store/components/DialogAddAgentApp.vue